var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("ledTable", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tableShow === "led",
      expression: "tableShow === 'led'"
    }],
    on: {
      "child-go": _vm.goChild
    }
  }), _vm.tableShow === "ledParam" ? _c("ledParamTable", {
    attrs: {
      current: _vm.current
    },
    on: {
      "child-go-led": _vm.goled,
      "child-go": _vm.goChild
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };